import React, { useEffect, useState } from "react";
import { Checkbox, Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  Modal,
  Backdrop,
  CircularProgress,
  Typography,
  Fade,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment/moment";
import EmptyData from "../../../StyledComponents/Table/EmptyData";
import TableSkeleton from "../../../StyledComponents/TableSkeleton";
import { useNavigate } from "react-router-dom";
import { ArrowBack, Error } from "@material-ui/icons";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },

    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "#e4e7e6",
    },
  },
});
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
function VFDownload({
  vendorList,
  loading,
  Batch,
  setBatch,
  setSuccessMessage,
  page,
  RowsPerPage,
  getInvoices,
  setBatchNo,
  batchNo,
  errorMessage,
}) {
  const navigate = useNavigate();
  const axios = require("axios");
  const [open, setOpen] = React.useState(false);
  const [detail, setDetail] = useState([]);
  const [returnloader, setreturnLoader] = React.useState(false);
  const [errorMessageDownload, setErrorMessageDownload] = useState("");
  const incoiceChecked = (e, Num) => {
    if (e.target.checked) {
      setBatchNo((batchNo) => [...batchNo, Num]);
      // setBatchNo([...batchNo,Num]);
    } else {
      let data = batchNo.filter((i) => i != Num);

      setBatchNo(data);
    }
  };
  const checkAll = (e) => {
    if (e.target.checked) {
      let data = vendorList.map((item) => {
        return item?.batchNo;
      });

      setBatchNo(data);
    } else {
      setBatchNo([]);
    }
  };

  const show = (position) => {
    let data = detail.filter((i) => i === position);

    if (data.length > 0) {
      setDetail(detail.filter((i) => i != position));
    } else {
      setDetail([...detail, position]);
    }
    // detail === position ? setDetail(false) : setDetail(position);
  };

  const handleOpen = (data) => {
    setBatch({ ...Batch, invoice: data });
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const returnBatch = () => {
    setreturnLoader(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/api/VFTreasury/BatchReturn?batchNo=${Batch.invoice}&remarks=${Batch.comment}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    };

    axios
      .request(config)
      .then((response) => {
        setreturnLoader(false);
        setSuccessMessage("Batch Return Successfully");
        getInvoices();

        setBatch({ ...Batch, comment: "" });
        setOpen(false);
      })
      .catch((error) => {
        setreturnLoader(false);
      });
  };

  const Download = (id) => {
    let save = false;
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/api/VFTreasury/DownloadZipFile?batchNo=${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    };

    axios
      .request(config)
      .then((response) => {
        const filePath = response.data; // Get the relative file path from the API response
        const absoluteURL = `${process.env.REACT_APP_API_URL
          }/${filePath.replace(/\\/g, "/")}`;

        const link = document.createElement("a");
        link.href = absoluteURL;
        link.download = "BatchInvoice.zip";
        link.click();
        setErrorMessageDownload("");

        // setTimeout(() => {
        //   setSuccessMessage("File Downloaded Successfully");
        // }, 3000);
      })
      .catch((error) => {
        console.log(error.response.data, "error.response.data");
        setErrorMessageDownload(error.response.data);
      });
  };

  const classes = useStyles();
  return (
    <Grid container style={{ margin: "20px 0px", overflowY: "auto" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} mt={3} style={{ width: "0" }}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ fontWeight: "bold" }}>
          {errorMessage && (
            <span style={{ color: "red", marginBottom: "5px" }}>
              {" "}
              Please Select Invoices!
            </span>
          )}
        </Grid>
        <TableContainer
          className="scrollable"
          // style={{
          //   maxHeight: "400px",
          //   minHeight: "100px",
          //   overflowY: "auto",
          //   marginTop: '-20px'
          // }}
        >
          <Table
            className={classes.table}
            aria-label="a dense table"
            // padding="normal"
            size="small"
            // sx={{
            //   height: 40,
            // }}
          >
            <TableHead style={{ position: "sticky", top: 0, zIndex: "1" }}>
              <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    color: "#031C30",
                    textAlign: "center",
                  }}
                >
                  <Checkbox
                    disabled={vendorList?.length == 0}
                    checked={
                      vendorList.length > 0 &&
                      batchNo.length === vendorList.length
                    }
                    onChange={checkAll}
                  />
                </TableCell>
                <TableCell
                  sx={{
                    // textAlign: "center",
                    fontWeight: "bold",
                    color: "#031C30",
                  }}
                >
                  Batch No
                </TableCell>
                <TableCell
                  sx={{
                    // textAlign: "center",
                    fontWeight: "bold",
                    color: "#031C30",
                  }}
                >
                  Batch Date
                </TableCell>
                <TableCell
                  sx={{
                    // textAlign: "center",
                    fontWeight: "bold",
                    color: "#031C30",
                  }}
                >
                  Maturity Date
                </TableCell>
                <TableCell
                  sx={{
                    // textAlign: "center",
                    fontWeight: "bold",
                    color: "#031C30",
                  }}
                >
                  Vendor
                </TableCell>
                <TableCell
                  sx={{
                    // textAlign: "center",
                    fontWeight: "bold",
                    color: "#031C30",
                  }}
                >
                  No of Invoices
                </TableCell>
                <TableCell
                  sx={{
                    // textAlign: "center",
                    fontWeight: "bold",
                    color: "#031C30",
                  }}
                >
                  Batch Amount
                </TableCell>
                <TableCell
                  sx={{
                    // textAlign: "center",
                    fontWeight: "bold",
                    color: "#031C30",
                  }}
                >
                  Download
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vendorList.length > 0 &&
                vendorList
                  ?.slice(page * RowsPerPage, page * RowsPerPage + RowsPerPage)
                  ?.map((item, id) => (
                    <>
                      <TableRow>
                        <TableCell sx={{ textAlign: "center" }}>
                          {item?.batchNo && (
                            <Checkbox
                              checked={batchNo?.includes(item?.batchNo)}
                              onChange={(e) => {
                                // setChecked(e.target.checked)
                                incoiceChecked(e, item?.batchNo);
                              }}
                            />
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            color: "black",
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => show(item.batchNo)}
                        >
                          {item?.batchNo}
                        </TableCell>
                        <TableCell style={{ color: "black", width: "15%" }}>
                          {item?.batchDate &&
                            moment(item?.batchDate).format("DD-MMM-YYYY")}
                        </TableCell>
                        <TableCell style={{ color: "black", width: "15%" }}>
                          {item?.maturityDate &&
                            moment(item?.maturityDate).format("DD-MMM-YYYY")}
                        </TableCell>
                        <TableCell style={{ color: "black", width: "20%" }}>
                          {item?.vendor}
                        </TableCell>
                        <TableCell style={{ color: "black", width: "15%" }}>
                          {item?.noOfInvoices}
                        </TableCell>
                        <TableCell style={{ color: "black", width: "15%" }}>
                          {Number(Number(item?.batchAmount)?.toFixed(2))?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ color: "black", width: "15%" }}>
                          <Button
                            variant="contained"
                            size="small"
                            color="secondary"
                            style={{
                              marginLeft: "6px",
                              padding: "5px",
                              marginTop: "10px",
                              marginBottom: "10px",
                            }}
                            onClick={() => {
                              Download(item?.batchNo);
                            }}
                          >
                            Download
                          </Button>

                          <Button
                            variant="contained"
                            size="small"
                            color="secondary"
                            style={{
                              marginLeft: "6px",
                              padding: "5px",
                              marginTop: "10px",
                              marginBottom: "10px",
                            }}
                            onClick={() => {
                              handleOpen(item?.batchNo);
                            }}
                          >
                            Comments
                          </Button>
                        </TableCell>
                      </TableRow>
                      {detail.some((arrVal) => item.batchNo === arrVal) ? (
                        <TableRow>
                          <TableCell colSpan={8}>
                            <Table
                              style={{ margin: "20px 0px" }}
                              aria-label="a dense table"
                              size="small"
                            >
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                      width: "10%",
                                    }}
                                  >
                                    S#
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Invoice Date
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Clearing Date
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Invoice No
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Invoice Description
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Invoice Amount
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    ITW Amount
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    STW Amount
                                  </TableCell>{" "}
                                  <TableCell
                                    sx={{
                                      // textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#031C30",
                                    }}
                                  >
                                    Net Amount
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {item.invoiceDetail.map((inv, index) => (
                                  <TableRow
                                    style={{ cursor: "pointer" }}
                                    className={classes.tableRow}
                                    onClick={() =>
                                      window.open(
                                        `/#/InvDetailPage?inv=${inv?.invoice_Id}&vendorCode=${inv.vendor_Code}`,
                                        "_blank"
                                      )
                                    }
                                    key={index}
                                  >
                                    <TableCell
                                      style={{ color: "black", width: "10%" }}
                                    >
                                      {index + 1}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "10%" }}
                                    >
                                      {inv?.invoice_Date &&
                                        moment(
                                          inv?.invoice_Date,
                                          "DD-MM-YYYY"
                                        ).format("DD-MMM-YYYY")}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "10%" }}
                                    >
                                      {inv?.clearing_Date &&
                                        moment(
                                          inv?.clearing_Date,
                                          "DD-MM-YYYY"
                                        ).format("DD-MMM-YYYY")}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "10%" }}
                                    >
                                      {inv?.invoice_No}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "15%" }}
                                    >
                                      {inv?.invoice_Desc}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "15%" }}
                                    >
                                      {Number(Number(inv?.inv_Amt)?.toFixed(2))?.toLocaleString()}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "10%" }}
                                    >
                                      {Number(Number(inv?.inc_Tax)?.toFixed(2))?.toLocaleString()}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "10%" }}
                                    >
                                      {Number(Number(inv?.wH_Tax)?.toFixed(2))?.toLocaleString()}
                                    </TableCell>
                                    <TableCell
                                      style={{ color: "black", width: "20%" }}
                                    >
                                      {Number(Number(inv?.net_Amount)?.toFixed(2))?.toLocaleString()}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                              {/* {item.invoiceDetail?.length === 0 ? (
                              <>
                                <EmptyData />
                              </>
                            ) : (
                              ""
                            )} */}
                            </Table>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                    </>
                  ))}
            </TableBody>
            {loading && <TableSkeleton noOfColumns={7} noOfLines={3} />}
          </Table>
          {vendorList?.length === 0 && !loading ? (
            <>
              <EmptyData />
            </>
          ) : (
            ""
          )}
        </TableContainer>
      </Grid>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={returnloader}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              Enter Comment:
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 1 }}>
              <TextField
                fullWidth={true}
                id="outlined-basic"
                variant="outlined"
                size="small"
                type="text"
                name="clearingDocuments"

                value={Batch.comment}
                onChange={(e) => {
                  setBatch({ ...Batch, comment: e.target.value });
                }}
              />
            </Typography>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              style={{
                marginLeft: "6px",
                padding: "5px",
                marginTop: "10px",
                marginBottom: "10px",
                float: "right",
              }}
              onClick={returnBatch}
            >
              Return to Batch
            </Button>
          </Box>
        </Fade>
      </Modal>
      {errorMessageDownload && (
        <>
          {" "}
          <Grid container spacing={0}>
            <Grid item>
              <Error
                titleAccess="Error"
                className={classes.asterisk}
                fontSize="small"
              />{" "}
            </Grid>
            <Grid item>
              <Typography className={classes.asterisk} ml={1}>
                {" "}
                {errorMessageDownload}
              </Typography>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default VFDownload;
